import ProductSupportTeamInquiry from '@/components/MedicalOnDemand/ProductSupportTeamInquiry';

export default ProductSupportTeamInquiry;
